import {Fab, Grid, useMediaQuery} from "@mui/material";
import {WhatsApp} from "@mui/icons-material";
import {theme} from "../../Tema";


export const useBotonWassFlotante = ({numero, mensaje = 'Hola Antonia, deseo mas informacion de congenar'}) => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))


    const irChat = () => {

        let texto = encodeURI(mensaje)
        let link = `https://api.whatsapp.com/send?phone=57${numero}&text=${texto}`
        window.open(link)

    }
    const BotonWass = () => {

        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{position: 'fixed', bottom: 30, left: sCell ? '77%' : '93%', zIndex: 8}}
            >

                <Fab
                    onClick={() => irChat()}
                    sx={{
                        backgroundColor: '#25D366',
                        '&:hover': {
                            backgroundColor: '#188842'
                        }

                    }}>
                    <WhatsApp sx={{width: 34, height: 34, fill: '#fff'}}/>
                </Fab>


            </Grid>
        )
    }

    return {

        BotonWass

    }
}
